var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAlert = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Alert")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/solid/alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(7.000000, 8.000000)",
    fill: "#0A1428",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2225507,23.9078967 C35.2513851,25.5517048 35.2513851,27.6064354 34.2225507,29.2502435 C33.3994595,30.8939336 31.7533953,31.9213579 29.6958446,31.9213579 L5.41648649,31.9213579 C3.56456081,31.9213579 1.71275338,30.8940517 0.889780405,29.2502435 C-0.139054054,27.6064354 -0.139054054,25.5517048 0.889780405,23.9078967 L13.0294595,2.74397048 C14.0582939,1.10028044 15.7043581,0.0728560886 17.5561655,0.0728560886 C19.4080912,0.0728560886 21.2598986,1.10016236 22.0828716,2.74397048 L34.2225507,23.9078967 Z M17.5561655,10.7574317 C16.9389358,10.7574317 16.5273311,11.1683542 16.5273311,11.7848561 L16.5273311,19.1819336 C16.5273311,19.7983173 16.9388176,20.2093579 17.5561655,20.2093579 C18.1733953,20.2093579 18.585,19.7984354 18.585,19.1819336 L18.585,11.7848561 C18.585,11.1683542 18.1733953,10.7574317 17.5561655,10.7574317 Z M17.5561655,22 C16.9389358,22 16.5273311,22.4109225 16.5273311,23.0274244 C16.5273311,23.6438081 16.9388176,24.0548487 17.5561655,24.0548487 C18.1733953,24.0548487 18.585,23.6439262 18.585,23.0274244 C18.585,22.4109225 18.1733953,22 17.5561655,22 Z",
    id: "Combined-Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert.d92614ef.svg";
export { ForwardRef as ReactComponent };